import { formatTextFloat, formatValueBillion } from '../../../helpers/Text';
import ConstTooltip from '../../../common/mixTable/tooltip/Const';
//config table
const listColumn = [
  {
    key: 'ticker',
    typeTooltip: ConstTooltip.typeHover.hoverScore,
    textAlign: 'left',
    isIconGraph: true,
    keyOrgCode: 'organCode',
    isUsingCellHover: false,
    isString: true,
  },
  {
    key: 'ranking',
    textAlign: 'right',
    isRanking: true,
    keyRank: 'icbRank',
    keyTotalRank: 'icbTotalRanked',
    thTooltip: 'table.strategy.ranking',
  },
  { key: 'icbName', textAlign: 'left', isDisSort: true, isDropDown: true },
  {
    key: 'rtd11',
    format: value => formatTextFloat(formatValueBillion(value), 2),
    textAlign: 'right',
  },
  {
    key: 'value',
    typeTooltip: ConstTooltip.typeHover.hoverValueScore,
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    isString: true,
    thTooltip: 'table.strategy.value',
  },
  {
    key: 'growth',
    typeTooltip: ConstTooltip.typeHover.hoverValueScore,
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    isString: true,
    thTooltip: 'table.strategy.growth',
  },
  {
    key: 'momentum',
    typeTooltip: ConstTooltip.typeHover.hoverValueScore,
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    tooltipHeight: 190,
    isString: true,
    thTooltip: 'table.strategy.momentum',
  },
  {
    key: 'vgm',
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    isString: true,
    thTooltip: 'table.strategy.vgm',
  },
];

export default {
  listCheckboxValueInvest: ['industry', 'group'],
  VALUE: 'VIS',
  GROWTH: 'GIS',
  MOMENTUM: 'MIS',
  VMG: 'VMG',
  LEADERS: 'LIS',
  listColumn,
  organCode: 'organCode',
  maxRowData: 10,
  COLORVALUE: '#f5761d',
  COLORGROWTH: '#f4485e',
  COLORMOMENTUM: '#2965cc',
  COLORVMG: '#6aaf5c',
  COLORLEADERS: '#9983d8',
};
